import React from 'react'
import {Trans} from 'react-i18next'
import {Link} from 'react-router-dom'
import {ROUTES} from '@/router/routes'
import {Text} from '@/components'

export const getSuccessExportMessage = () => (
    <span>
        <Trans
            i18nKey='messages.successExportMessage'
            ns='globals'
            components={{
                span: <span />,
                a: <Link to={ROUTES.exports} />
            }}
        />
    </span>
)

export const getLinkSentToName = (name: string) => (
    <Trans
        i18nKey='pay-by-link.linkSentToName'
        values={{name}}
        components={{
            strong: <Text strong />
        }}
    />
)
